import React, { ChangeEventHandler } from "react";
import { Input } from "antd";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    onChange: ChangeEventHandler<HTMLInputElement>
}

export default function PasswordInput({ value, onChange, className, ...props }: Props) {
    const [passwordVisible, setPasswordVisible] = React.useState(false);

    return (
        <Input.Password
            className={className}
            value={value}
            onChange={onChange}
            placeholder="input password"
            visibilityToggle={{
                visible: passwordVisible,
                onVisibleChange: setPasswordVisible,
            }}
        />
    );
}
